import React from 'react';
import { IconLongArrowUpBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface ScrollButtonsProps {
  handleClick: (direction: 'top' | 'bottom') => void;
}
export const ScrollButtons: React.FC<React.PropsWithChildren<ScrollButtonsProps>> = React.memo(({ handleClick }) => {
  return (
    <Container>
      <Button
        type='button'
        aria-label='맨 위로 가기'
        direction='up'
        onClick={() => handleClick('top')}
        data-allow-preview
      >
        <IconLongArrowUpBold width={24} height={24} v3Color='gray400' />
      </Button>
      <Button
        type='button'
        aria-label='맨 아래로 가기'
        direction='down'
        onClick={() => handleClick('bottom')}
        data-allow-preview
      >
        <IconLongArrowUpBold width={24} height={24} v3Color='gray400' />
      </Button>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 16px;
  top: -104px;
  transition: top 0.1s ease-in-out;
`;

const Button = styled.button<{ direction: 'up' | 'down' }>`
  -webkit-tap-highlight-color: transparent;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  background-color: ${vars.v3Color.staticWhite};
  transform: translate3d(0, 0, 0);
  svg {
    ${({ direction }) => direction === 'down' && 'transform: rotateX(180deg)'};
  }

  &:first-of-type {
    margin-bottom: 8px;
  }
`;
